import React from 'react';
import { ModalDialog } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import '../../../styles/css/Modal.css';
import '../../../styles/css/ModalTabs.css';
import withTranslations from '../../../utils/HighOrderComponent.js';
import ButtonSave from '../ButtonSave.js';
import { confirmDialog } from '../ConfirmDialog.js';
import LoadingIndicator from '../LoadingIndicator';
import DraggableModal from './DraggableModal';
import ModalFooter from './ModalFooter';

const CustomModal = ({
  show,
  hideModal,
  title,
  additionalTitleInfo,
  modalSize,
  secondModal,
  wideModal,
  children,
  draggable,
  backdrop,
  removeRoundedEdges,
  footer = true,
  centered = true,
  className = '',
  footerContent,
  closeButton = true,
  spinnerSize = 110,
  footerButtonLabel,
  onFooterButtonClick,
  historyLoginModal,
  showOnComponentLevel,
  loading,
  submitRef,
  saveButtonClassName,
  showDefaultFooter,
  customSaveButtonLabel,
  customSaveButtonIcon,
  t,
  gt,
  isView,
  hideCloseButtonMessage = false,
  hideFooterCancelButton = false,
  hideSaveButton = false,
  showCloseButton = false,
  exportButton = false,
}) => {
  const size = modalSize || 'lg';
  let defaultClassName = '';
  if (secondModal) {
    defaultClassName = 'second-modal';
  } else if (wideModal) {
    defaultClassName = 'wide-modal';
  }
  if (secondModal && wideModal) {
    defaultClassName = `second-modal wide-modal`;
  }

  if (removeRoundedEdges) defaultClassName += ' clear-border-modal ';

  if (draggable) defaultClassName += ' draggable-modal ';

  if (historyLoginModal) defaultClassName = 'history-login-modal';

  const backdropValue = backdrop || 'static';

  const renderDialogAs = draggable ? DraggableModal : ModalDialog;

  const modalTitle = additionalTitleInfo
    ? `${title} - ${additionalTitleInfo}`
    : title;

  const { ConfirmDialog } = t || {};

  const buttonClassName = historyLoginModal
    ? 'save-button'
    : 'col-md-6 shadow-2 m-auto grid-button';

  const defaultFooter = () => {
    return (
      <ButtonSave
        label={footerButtonLabel}
        className={buttonClassName}
        onClick={onFooterButtonClick}
      />
    );
  };

  const cancelActionHandler = () => {
    if (showCloseButton && !isView)
      hideCloseButtonMessage
        ? hideModal()
        : confirmDialog(
            ConfirmDialog.confirmCloseMessage,
            () => hideModal(),
            '',
            gt
          );
    else if (!hideFooterCancelButton && !isView)
      confirmDialog(ConfirmDialog.confirmMessage, () => hideModal(), '', gt);
    else hideModal();
  };

  return (
    <Modal
      show={show}
      onHide={cancelActionHandler}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered={centered}
      className={`${defaultClassName} ${className}`}
      backdrop={backdropValue}
      dialogAs={renderDialogAs}
      scrollable
    >
      <LoadingIndicator
        loading={loading}
        showOnComponentLevel={showOnComponentLevel}
        spinnerSize={spinnerSize}
      />
      <Modal.Header closeButton={closeButton}>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">{children}</Modal.Body>
      {!!footer && (
        <ModalFooter
          hideFooterCancelButton={hideFooterCancelButton}
          submitRef={submitRef}
          hideSaveButton={hideSaveButton}
          showCloseButton={showCloseButton}
          exportButton={exportButton}
          hideModal={hideModal}
          footerContent={showDefaultFooter ? defaultFooter() : footerContent}
          saveButtonClassName={saveButtonClassName}
          customSaveButtonLabel={customSaveButtonLabel}
          customSaveButtonIcon={customSaveButtonIcon}
          onCancelActionHandler={() => cancelActionHandler()}
        />
      )}
    </Modal>
  );
};

export default withTranslations(CustomModal, 'CustomModal');
